import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";

export type OptionsMenuProps = {
  name: string;
  functionMenu: any;
};

export type EllipsesMenuProps = {
  name: string;
  options: OptionsMenuProps[];
  isLast?: boolean;
};

const EllipsesMenu: React.FC<EllipsesMenuProps> = ({
  name,
  options,
  isLast = false,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-6 w-6"
        />
      </MenuButton>
      <MenuItems
        transition
        className={`absolute z-50 w-32 rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none
        ${isLast ? "bottom-full mb-2" : "mt-2 top-full"} md:right-0`}
      >
        {options?.map((option, idx) => (
          <MenuItem key={idx}>
            <a
              href="#"
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left"
              onClick={option.functionMenu}
            >
              {option.name}
              <span className="sr-only">, {name}</span>
            </a>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenu;
